
import {Component, Vue} from "vue-property-decorator";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {ITask, ITasks, PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Socket} from "vue-socket.io-extended";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {
  childTasksUrl,
  ebeveynGorevTuru,
  gorevHash,
  hashKaydiniSil,
  HashSilmeTakibi
} from "@/helpers/HashSilmeHelper";

@Component({
  components: {DeleteDialog}
})
export default class MtsTakipAcIslemDetayView extends Vue {
  @Socket('updateTasks')
  onUpdateTask() {
    this.load();
  }

  onFly = false;
  downloading = false;
  headers = [
    {text: 'Esas No', value: 'esasNo'},
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Alacaklılar', value: 'alacaklilar'},
    {text: 'Borçlular', value: 'borclular'},
    {text: 'Takibe Esas Tutar', value: 'toplamTakibeEsasMiktar'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
  ];
  seciliHataliGorevler = [];
  items = [];
  loading = false;
  hataliHeaders = [
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Alacaklılar', value: 'alacaklilar'},
    {text: 'Borçlular', value: 'borclular'},
    {text: 'Takibe Esas Tutar', value: 'toplamTakibeEsasMiktar'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
    { text: "İşlemler", value: "actions" },
  ];
  taskDurum = TaskDurum;
  programPaths = ProgramPaths;
  playerDurum = PlayerDurum;
  hashSilme = new HashSilmeTakibi();

  get isFirstTask(): boolean {
    return this.$store.getters.getSiradakiGorevler[0]?.id == this.$route.params.id;
  }

  get paternTask(): ITask {
    let tasks: ITasks = this.$store.getters.getGorevler;
    let allTaskt: Array<ITask> = [...tasks.incomplete_tasks, ...tasks.completed_tasks];
    return allTaskt.find((task: ITask) => task.id == this.$route.params.id) as ITask;
  }

  // DEV-3302: satırda task_type_id yoksa ödeme görevi (mts_takip_ac) kontrolü üst görevin türüne bakar.
  get ebeveynTuru(): number | null {
    return ebeveynGorevTuru(this.$store.getters.getGorevler, this.$route.params.id);
  }

  async mounted(){
    await this.load()
  }

  async load() {
    const sira = this.hashSilme.yuklemeBasladi();
    try {
      this.loading = true;
      const response = await this.$http.get(childTasksUrl(this.$route.params.id));
      // DEV-3302: socket updateTasks yüklemeleri sırasız dönebilir; eski yanıt yeni durumu ezmesin.
      if (!this.hashSilme.yanitGeldi(sira, response.data))
        return;
      this.items = response.data;
    } catch (e) {
      if (this.hashSilme.eskiYanitMi(sira))
        return;
      // Satırlar korunur: silmeden sonraki load() hata verirse tablo boşalmasın.
      this.$toast.error("İşlemler getirilirken hata oluştu. " + e.message);
    } finally {
      if (this.hashSilme.sonIstekMi(sira))
        this.loading = false;
    }
  }

  deleteHash(item: ITask): Promise<void> {
    return hashKaydiniSil(this.$http, this.$toast, gorevHash(item));
  }

  // DeleteDialog @success: aynı hash'li hatalı satırlar hemen gizlenir, sunucu doğrusu load() ile gelir.
  hashSilindi(item: ITask): void {
    this.hashSilme.silindi(item, this.items);
    this.load();
  }

  downloadExcel() {
    this.downloading = true;
    this.$helper.download('Excel Sonuçlar.xlsx', '/api/v1/export-to-excel/' + this.$route.params.id).finally(() => {
      this.downloading = false;
    });
  }

  async durdurDevamEt() {
    if (this.$store.getters.getPlayerDurum == this.playerDurum.oto) {
      this.$socket.client.emit("player", this.playerDurum.durduruluyor);
    } else {
      this.$socket.client.emit("player", this.playerDurum.oto);
    }
  }

  selectAllToggle() {
    let hatalilar = this.items.filter((item:ITask) => (item.status === this.taskDurum.BITTI_HATALI || item.status === this.taskDurum.YENIDEN_BASLATILDI));
    if (this.seciliHataliGorevler.length === hatalilar.length) {
      this.seciliHataliGorevler = [];
    } else {
      this.seciliHataliGorevler = hatalilar.filter(item => item.status !== this.taskDurum.YENIDEN_BASLATILDI);
    }
  }

  async tryAgainCreateTask() {
    if (this.seciliHataliGorevler.length > 0) {
      this.onFly = true;
      let tasks: Array<ITask> = [];
      this.seciliHataliGorevler.forEach((item: any) => {
        let task: ITask = {...item};
        task.id = null;
        task.status = TaskDurum.SIRADA;
        task.response = null;
        task.parent_id = null;
        tasks.push(task);
      });
      let takiplerEsasNoYok = this.seciliHataliGorevler.map((takip: ITask) => (takip.birim_adi)).join(", ");
      tasks[0].aciklama = takiplerEsasNoYok + " hatalı takiplerin yeniden açılması."
      try {
        await this.$store.dispatch('postTasks', tasks);
        let req = { ids: this.seciliHataliGorevler.map((gorev: ITask) => gorev.id), status: TaskDurum.YENIDEN_BASLATILDI};
        await this.$http.post('/api/v1/task/update-status', req);
        await this.$store.dispatch('getTasksFromServer');
        await this.load();
        await this.$router.push(this.programPaths.eicrapro + '/islemler');
      } catch (e) {
        console.error(e)
      } finally {
        this.seciliHataliGorevler = [];
        this.onFly = false;
      }
    } else {
      this.$toast.info('Yeniden başalatılacak görevleri seçiniz.')
    }
  }
}
